import axios from 'axios';
import ActionTypes from '../constants/ActionTypes';

const api = axios.create({
  baseURL:
    typeof SERVER === 'undefined' || SERVER // eslint-disable-line no-undef
      ? `http://localhost:${typeof PORT === 'undefined' ? '10010' : PORT}` // eslint-disable-line no-undef
      : '/'
});

export const fetchCategory = id => {
  return async dispatch => {
    if (!id) return;
    try {
      const { data: category } = await api.get(`/api/opus/category/${id}`);
      return dispatch({
        type: ActionTypes.FETCH_CATEGORY_SUCCESS,
        payload: category
      });
    } catch (e) {
      return dispatch({
        type: ActionTypes.FETCH_CATEGORY_ERROR,
        payload: { id }
      });
    }
  };
};

export const fetchCategorySuggestions = id => {
  return async dispatch => {
    if (!id) return;
    try {
      const { data: category } = await api.get(`/api/opus/category/${id}/suggestions`);
      return dispatch({
        type: ActionTypes.FETCH_CATEGORY_SUGGESTIONS_SUCCESS,
        payload: category
      });
    } catch (e) {
      return dispatch({
        type: ActionTypes.FETCH_CATEGORY_SUGGESTIONS_ERROR,
        payload: { id }
      });
    }
  };
};

export const fetchCategories = () => {
  return async dispatch => {
    try {
      const { data: categories } = await api.get(`/api/opus/categories`);
      return dispatch({
        type: ActionTypes.FETCH_CATEGORIES_SUCCESS,
        payload: categories
      });
    } catch (e) {
      return dispatch({
        type: ActionTypes.FETCH_CATEGORIES_ERROR
      });
    }
  };
};
